export const KB = 1024;

export function truncateJSON(value: unknown, capBytes = 256 * KB): { preview: string; truncated: boolean } {
  const s = typeof value === 'string' ? value : JSON.stringify(value, null, 2);
  if (new Blob([s]).size <= capBytes) return { preview: s, truncated: false };
  const head = s.slice(0, Math.floor(capBytes * 0.6));
  const tail = s.slice(-Math.floor(capBytes * 0.3));
  return { preview: `${head}\n…\n/* truncated */\n…\n${tail}`, truncated: true };
}

